<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch13"></a><a id="page_14"></a><a href="#/contents#ch13"><b>Sports Milestones</b></a></h2>
<p class="noindent"><span>Most strikeouts thrown in one baseball game: 21, by the Washington Senators’ Tom Cheney, in 16 innings (1962).</span></p>
<p class="noindent"><span>In 1954, Roger Bannister was the first person to run a mile in under four minutes, with a time of 3:59.4.</span></p>
<p class="noindent"><span>Ray Harroun was the first winner of the Indianapolis 500, in 1911.</span></p>
<p class="noindent"><span>In 1986, American Greg LeMond became the first non-European to win the Tour de France.</span></p>
<p class="noindent"><span>Tallest golfer to play on the PGA Tour: Phil Blackmar (6'7").</span></p>
<p class="noindent"><span>In 1981, John Henry was the first Thoroughbred to win a million-dollar race.</span></p>
<p class="noindent"><span>In 1926, Gertrude Ederle became the first woman to swim the English Channel. Only five men had done it before her.</span></p>
<p class="noindent"><span>Most seasons as a major-league baseball umpire: Bill Klem and Bruce Froemming, each with 37 years.</span></p>
<p class="noindent"><span>First Asian American woman to win an Olympic gold medal: figure skater Kristi Yamaguchi, in 1992.</span></p>
<p class="noindent"><span>The winner of the first Kentucky Derby was Aristides, ridden by Oliver Lewis, on May 17, 1875.</span></p>
<p class="noindent"><span>First basketball player to enter the NBA directly from high school: Reggie Harding in 1962.</span></p>
<p class="noindent"><span>The first Ironman Triathlon was held in Hawaii in 1978.</span></p>
<p class="noindent"><span>The New York Yankees have won 26 championships, more than any other professional sports team.</span></p>
<p class="noindent"><span>Late 19th-century boxer John L. Sullivan was the first American sports figure to become a national celebrity.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter13.vue?cbd59272